import React, { useState, useEffect } from "react";
import settingsService from "./services/settingsService";

function WhatsAppButton() {
  const [phoneNumber, setPhoneNumber] = useState("918754545419");
  const [message, setMessage] = useState("Hello VJ Dsign Studio, I would like to enquire about your interior designs!");

  useEffect(() => {
    async function loadSettings() {
      try {
        const general = await settingsService.getSetting("general");
        const all = await settingsService.getAll();
        
        const raw = (all?.whatsapp_number || general?.whatsapp || all?.phone || general?.phone_raw || "").replace(/[^0-9]/g, "");
        if (raw) {
          setPhoneNumber(raw);
        }
        if (all?.whatsapp_message || general?.whatsapp_message) {
          setMessage(all.whatsapp_message || general.whatsapp_message);
        }
      } catch (err) {
        // Fallback to default
      }
    }
    loadSettings();
  }, []);
  
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <>
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contact us on WhatsApp"
        className="
          fixed 
          bottom-6 
          right-6 
          z-50 
          flex 
          items-center 
          justify-center 
          w-14 
          h-14 
          sm:w-16 
          sm:h-16 
          bg-[#25D366] 
          rounded-full 
          shadow-xl 
          hover:shadow-[0_8px_30px_rgb(37,211,102,0.4)]
          hover:-translate-y-1 
          transition-all 
          duration-300 
          group
        "
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366]/40 animate-ping-slow pointer-events-none"></span>

        <svg
          className="w-7 h-7 sm:w-8 sm:h-8 text-white fill-current transition-transform duration-300 group-hover:scale-110"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946C.06 5.348 5.397.01 12.008.01c3.202.001 6.212 1.243 8.477 3.508 2.266 2.264 3.507 5.275 3.507 8.482 0 6.656-5.338 12.001-11.947 12.001-1.997-.001-3.957-.502-5.69-1.458L0 24zm6.59-4.846c1.6.95 3.477 1.451 5.398 1.452 5.4 0 9.794-4.402 9.797-9.817.002-2.624-1.017-5.09-2.868-6.944-1.85-1.854-4.314-2.875-6.94-2.877-5.404 0-9.801 4.402-9.805 9.817-.001 1.93.501 3.81 1.456 5.416l-.993 3.626 3.715-.974zm11.023-4.04c-.3-.15-1.772-.875-2.046-.975-.276-.102-.476-.152-.676.152-.202.302-.777.974-.952 1.176-.176.202-.351.226-.651.075-.302-.15-1.274-.469-2.427-1.496-.897-.8-1.502-1.79-1.279-2.09.223-.301.302-.451.452-.752.15-.301.075-.551-.038-.752-.113-.202-.677-1.631-.925-2.231-.242-.582-.487-.504-.676-.514-.175-.01-.376-.01-.577-.01-.201 0-.527.075-.802.376-.276.301-1.053 1.028-1.053 2.507 0 1.478 1.077 2.909 1.227 3.11.15.201 2.118 3.237 5.132 4.541.717.311 1.276.496 1.712.635.722.229 1.378.196 1.9.118.579-.087 1.772-.726 2.022-1.429.25-.701.25-1.302.175-1.428-.075-.126-.275-.201-.575-.352z" />
        </svg>
      </a>

      <style>
        {`
          @keyframes pingSlow {
            75%, 100% {
              transform: scale(1.6);
              opacity: 0;
            }
          }
          .animate-ping-slow {
            animation: pingSlow 2s cubic-bezier(0, 0, 0.2, 1) infinite;
          }
        `}
      </style>
    </>
  );
}

export default WhatsAppButton;